import { useState, useEffect } from 'react';
import { useAuthContext } from '@/features/auth/contexts/auth-context';
import { EmisorConfig } from '../utils/de-types';

const EMISOR_CONFIG_KEY = 'emisor_facturacion_config';

export function useEmisorConfig() {
    const { authData } = useAuthContext();
    const storageKey = authData?.organizacionId
        ? `${EMISOR_CONFIG_KEY}_${authData.organizacionId}`
        : EMISOR_CONFIG_KEY;

    const [config, setConfig] = useState<EmisorConfig | null>(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const loadConfig = () => {
            try {
                const stored = localStorage.getItem(storageKey);
                if (stored) {
                    const parsedConfig = JSON.parse(stored) as EmisorConfig;
                    setConfig(parsedConfig);
                } else {
                    setConfig(null);
                }
            } catch (error) {
                console.error('Error loading emisor config:', error);
            } finally {
                setIsLoading(false);
            }
        };

        loadConfig();

        const handleStorageChange = () => {
            loadConfig();
        };

        //codigo para actualizar en los chips los cambios al hacerlos desde la página de facturacion electronica
        window.addEventListener('storage', handleStorageChange);

        return () => {
            window.removeEventListener('storage', handleStorageChange);
        };
    }, [storageKey]);

    const saveConfig = (newConfig: EmisorConfig) => {
        try {
            localStorage.setItem(storageKey, JSON.stringify(newConfig));
            setConfig(newConfig);
            window.dispatchEvent(new Event('storage'));
        } catch (error) {
            console.error('Error saving emisor config:', error);
            throw error;
        }
    };

    const clearConfig = () => {
        try {
            localStorage.removeItem(storageKey);
            setConfig(null);
        } catch (error) {
            console.error('Error clearing emisor config:', error);
        }
    };

    const isConfigValid = config &&
        config.establecimiento &&
        config.puntoExpedicion

    return {
        config,
        isLoading,
        isConfigValid,
        saveConfig,
        clearConfig,
        hasConfig: !!config
    };
}
